export const APPCHARGE_COOKIE_POLICY_URL = 'https://appcharge.com/cookie-policy/';
export const APPCHARGE_PRIVACY_POLICY_URL = 'https://appcharge.com/privacy-policy/';
export const APPCHARGE_PRIVACY_EMAIL = 'privacy@appcharge.com';
